import { CardActionArea } from "@mui/material"
import { Link } from "react-router-dom"
import { safeMergeSx } from "../../../../../utils"
import { Chevron, confHoverChevron } from "../../commons"
import { LinkBox, type LinkBoxProps } from "../LinkBox"
import { type CardLinkBoxSlotProps, LinkCard } from "../commons"

export interface InternalLinkBoxProps
  extends Omit<LinkBoxProps, "RightIcon" | "slotProps"> {
  to: string
  bgcolor?: string
  slotProps?: CardLinkBoxSlotProps<typeof Chevron>
}

export const InternalLinkBox = ({
  to,
  bgcolor,
  slotProps,
  ...props
}: InternalLinkBoxProps) => {
  return (
    <LinkCard bgcolor={bgcolor} {...slotProps?.card}>
      <CardActionArea
        component={Link}
        to={to}
        {...slotProps?.cardActionArea}
        sx={safeMergeSx(
          { p: 3, ...confHoverChevron },
          slotProps?.cardActionArea?.sx,
        )}
      >
        <LinkBox
          {...props}
          slotProps={slotProps?.linkBox}
          RightIcon={<Chevron {...slotProps?.rightIcon} />}
        />
      </CardActionArea>
    </LinkCard>
  )
}
